var Sidebar_1;
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { EventbusType, ModalType } from '@movecloser/front-core';
import { NavigationServiceType, NavigationSlot } from '@service/navigation';
import { Inject } from '@plugin/inversify';
import { SiteLogoVariant, SiteServiceType } from '@service/site';
import { Search } from '@component/Search';
import { SidebarNav } from './SidebarNav';
import { SitesNav } from '../SitesNav';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let Sidebar = Sidebar_1 = class Sidebar extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the sidebar is currently open.
         */
        this.isOpen = false;
    }
    /**
     * Determines whether the User is currently logged-in.
     */
    // private get isUserLoggedIn (): boolean {
    //   return this.$store.getters['profile/isUserLoggedIn']
    // }
    get logotype() {
        const logoSize = this.site.properties.logoSize;
        return {
            src: this.site.logo[SiteLogoVariant.Light] || '',
            width: logoSize === null || logoSize === void 0 ? void 0 : logoSize.width,
            height: logoSize === null || logoSize === void 0 ? void 0 : logoSize.height
        };
    }
    get mainLinks() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.Left)
            ? ((_a = this.navigation.getSlot(NavigationSlot.Left)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get relatedSitesLinks() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.RelatedSites)
            ? ((_a = this.navigation.getSlot(NavigationSlot.RelatedSites)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get bottomLinks() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.FooterTop)
            ? ((_a = this.navigation.getSlot(NavigationSlot.FooterTop)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    // public get shouldRenderSubscriptionBtn (): boolean {
    //   return this.navigation.getSubscriptionButtonState()
    // }
    get site() {
        return this.siteService.getActiveSite();
    }
    get socialLinks() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.Social)
            ? ((_a = this.navigation.getSlot(NavigationSlot.Social)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    // public get sitesList (): NavigationItem[] {
    //   return []
    // }
    /**
     * Vue lifecycle hook.
     */
    mounted() {
        this.attachListeners();
    }
    /**
     * Handles the `@click` event on the "log-in" button.
     */
    // public onLogInBtnClick (): void {
    //   this.modalConnector.open(EModal.LogIn)
    // }
    onOverlayClick(e) {
        if (e.target && e.target instanceof HTMLElement && !e.target.classList.contains('sidebar')) {
            return;
        }
        this.close();
    }
    /**
     * Attaches all the needed event listeners.
     */
    attachListeners() {
        this.eventBus.handle('ui:sidebar.close', this.close);
        this.eventBus.handle('ui:sidebar.open', this.open);
        this.eventBus.handle('ui:sidebar.toggle', this.toggle);
    }
    /**
     * Closes the sidebar.
     */
    close() {
        this.isOpen = false;
        document.body.classList.remove('--open');
        Sidebar_1.unlockBodyScroll();
        this.litMainContent();
        this.eventBus.emit('ui:sidebar.changed', { isOpen: false });
    }
    /**
     * Dims main content of the page.
     */
    dimMainContent() {
        this.eventBus.emit('ui:layout.dim');
    }
    /**
     * Lits main content of the page up.
     */
    litMainContent() {
        this.eventBus.emit('ui:layout.lit');
    }
    /**
     * Prevents the `<body>` from scrolling.
     */
    static lockBodyScroll() {
        document.documentElement.style.setProperty('--scroll-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
        document.documentElement.classList.add('--no-scroll');
    }
    /**
     * Opens the sidebar.
     */
    open() {
        this.isOpen = true;
        document.body.classList.add('--open');
        Sidebar_1.lockBodyScroll();
        this.dimMainContent();
        this.eventBus.emit('ui:sidebar.changed', { isOpen: true });
    }
    /**
     * Toggles (opens/closes) the sidebar.
     */
    toggle() {
        this.isOpen ? this.close() : this.open();
    }
    /**
     * Re-enables the `<body>` scroll.
     */
    static unlockBodyScroll() {
        document.documentElement.classList.remove('--no-scroll');
    }
};
__decorate([
    Inject(EventbusType)
], Sidebar.prototype, "eventBus", void 0);
__decorate([
    Inject(ModalType)
], Sidebar.prototype, "modalConnector", void 0);
__decorate([
    Inject(NavigationServiceType)
], Sidebar.prototype, "navigation", void 0);
__decorate([
    Inject(SiteServiceType)
], Sidebar.prototype, "siteService", void 0);
Sidebar = Sidebar_1 = __decorate([
    Component({
        name: 'Sidebar',
        components: {
            Search,
            SidebarNav,
            SitesNav
        }
    })
], Sidebar);
export { Sidebar };
export default Sidebar;
